export const SAVE_SCHEDULE_TIMING = "SAVE_SCHEDULE_TIMING"
export const SAVE_SCHEDULE_TIMING_FAIL = "SAVE_SCHEDULE_TIMING_FAIL"
export const SAVE_SCHEDULE_TIMING_SUCCESS = "SAVE_SCHEDULE_TIMING_SUCCESS"
export const SAVE_SCHEDULE_TIMING_RESET = "SAVE_SCHEDULE_TIMING_RESET"

export const saveScheduleTiming = (params) => {
    return { type: SAVE_SCHEDULE_TIMING, params }
}
export const saveScheduleTimingFail = (response) => {
    console.log(response)
    return { type: SAVE_SCHEDULE_TIMING_FAIL, response }
}
export const saveScheduleTimingSuccess = (response) => {
    //console.log(response)
    return { type: SAVE_SCHEDULE_TIMING_SUCCESS, response }
}
export const saveScheduleTimingReset = () => {
    return { type: SAVE_SCHEDULE_TIMING_RESET }
}